"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("../types");
var seenKeys = {};
var MULTIPLIER = Math.pow(2, 24);
var RawDraftContentBlockBuilder = /** @class */ (function () {
    function RawDraftContentBlockBuilder() {
        this.block = {
            data: {},
            depth: 0,
            entityRanges: [],
            inlineStyleRanges: [],
            key: generateRandomKey(),
            text: '',
            type: types_1.DraftBlockType.UNSTYLED,
        };
    }
    RawDraftContentBlockBuilder.prototype.withText = function (text) {
        this.block.text = text;
        return this;
    };
    RawDraftContentBlockBuilder.prototype.build = function () {
        return this.block;
    };
    return RawDraftContentBlockBuilder;
}());
exports.RawDraftContentBlockBuilder = RawDraftContentBlockBuilder;
function generateRandomKey() {
    var key;
    while (key === undefined || seenKeys.hasOwnProperty(key) || !isNaN(+key)) {
        key = Math.floor(Math.random() * MULTIPLIER).toString(32);
    }
    seenKeys[key] = true;
    return key;
}
//# sourceMappingURL=RawDraftContentBlockBuilder.js.map